import {Comment} from "@api/models/comments/Comment";

export const commentSortingValue = (comment: Comment, isAdmin: boolean, currentUserId: number) => {
    if (comment.isPublished !== undefined && !isAdmin && comment.userId != currentUserId) {
        return comment.publishedAt;
    }
    return comment.createdAt;
}
